import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result, UseCase, Guard } from '@digibricks/domains';
export var DELETE_ANSWER_COMMENT_USE_CASE = 'DELETE_ANSWER_COMMENT_USE_CASE';
export var DeleteAnswerCommentUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(DeleteAnswerCommentUseCase, _UseCase);

  var _super = _createSuper(DeleteAnswerCommentUseCase);

  function DeleteAnswerCommentUseCase(submissionRepository) {
    var _this;

    _classCallCheck(this, DeleteAnswerCommentUseCase);

    _this = _super.call(this);
    _this.submissionRepository = submissionRepository;
    return _this;
  }

  _createClass(DeleteAnswerCommentUseCase, [{
    key: "validate",
    value: function validate(useCaseInput) {
      var collection = [{
        argument: useCaseInput.submissionId,
        argumentName: 'Submission Id'
      }, {
        argument: useCaseInput.commentId,
        argumentName: 'Essay Comment Id'
      }, {
        argument: useCaseInput.submissionAnswerContent,
        argumentName: 'Essay Answer Content'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(collection);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      return Result.ok();
    }
  }, {
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(useCaseInput) {
        var resultOrError, answer, commentId, submissionId, id, submissionAnswerContent, deleteAnswerComment, deleteAnswerCommentOrError;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                resultOrError = this.validate(useCaseInput);

                if (!resultOrError.isFailure) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", Result.fail(resultOrError.error));

              case 3:
                answer = useCaseInput.answer, commentId = useCaseInput.commentId, submissionId = useCaseInput.submissionId, id = useCaseInput.id, submissionAnswerContent = useCaseInput.submissionAnswerContent;
                deleteAnswerComment = {
                  id: id,
                  submissionId: submissionId,
                  commentId: commentId,
                  submissionAnswerContent: submissionAnswerContent
                };
                _context.next = 7;
                return this.submissionRepository.deleteAnswerComment(deleteAnswerComment);

              case 7:
                deleteAnswerCommentOrError = _context.sent;

                if (!deleteAnswerCommentOrError.isFailure) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return", Result.fail(deleteAnswerCommentOrError.error));

              case 10:
                answer.deleteAnswerComment(commentId, submissionAnswerContent);
                return _context.abrupt("return", Result.ok(answer));

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return DeleteAnswerCommentUseCase;
}(UseCase);